import React, {useEffect, useState} from 'react'
import FetchUtil from "../../../util/FetchUtil";
import ConfigUtil from "../../../util/ConfigUtil";
import ConfirmDialog from "../../general/ConfirmDialog";
import ErrorInfoComponent from "../../general/ErrorInfoComponent";
import ConfirmWithQuestionDialog from "../../general/ConfirmWithQuestionDialog";
import DHPasswordField from "../../general/DHPasswordField";
import DHButtonSave from "../../general/DHButtonSave";
import DHButtonDefault from "../../general/DHButtonDefault";
import DHButtonIconDelete from "../../general/DHButtonIconDelete";
import DHButtonIconCheck from "../../general/DHButtonIconCheck";

export default function KennwortAendernArea({onLogout}) {

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    const [externPersonMatch, setExternPersonMatch] = useState(undefined);

    const [id, setId] = useState("");
    const [currentPassword, setCurrentPassword] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");
    const [showLoeschenDialog, setShowLoeschenDialog] = useState(false);
    const [showExternPersonConfirmDialog, setShowExternPersonConfirmDialog] = useState(false);
    const [showExternPersonDeleteDialog, setShowExternPersonDeleteDialog] = useState(false);

    useEffect(() => {
        ladeDaten();
    }, []);

    const ladeDaten = () => {
        setErrorMessage(undefined);
        FetchUtil.fetchGet(ConfigUtil.getConfig().resourceUrls.nu + "/player/match",
            json => {
                setExternPersonMatch(json);
            },
            responseNotOk => {
                setErrorMessage("Fehler beim Laden: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler beim Laden: " + error.message);
            }
        );
    }

    const deleteVerknuepfung = () => {
        FetchUtil.fetchDelete(ConfigUtil.getConfig().resourceUrls.nu + "/player/match/delete/" + externPersonMatch.id,
            {},
            () => {
                setInfoMessage("Verknüpfung wurde gelöscht.");
                setShowExternPersonDeleteDialog(false);
                ladeDaten()
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
                setShowExternPersonDeleteDialog(false);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
                setShowExternPersonDeleteDialog(false);
            }
        );
    }
    const confirmVerknuepfung = () => {
        setErrorMessage(undefined);

        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.nu + "/player/match/confirm/" + externPersonMatch.id,
            {},
            json => {
                setInfoMessage("Die Verknüpfung wurde bestätigt.");
                ladeDaten();
                setShowExternPersonConfirmDialog(false);
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
                setShowExternPersonConfirmDialog(false);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
                setShowExternPersonConfirmDialog(false);
            }
        );
    }

    const changeUsername = () => {
        setErrorMessage(undefined);

        if (username === "" || currentPassword === "") {
            setErrorMessage("Benutzername u. Kennwort müssen gefüllt sein.");
            return;
        }
        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.user + "/changeusername",
            {username: username, password: currentPassword},
            json => {
                onLogout();
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
                setShowLoeschenDialog(false);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
                setShowLoeschenDialog(false);
            }
        );
    }

    const loeschen = () => {
        setErrorMessage(undefined);

        if (currentPassword === "") {
            setErrorMessage("Du musst dein aktuelles Kennwort eingeben.");
            setShowLoeschenDialog(false);
            return;
        }
        FetchUtil.fetchDelete(ConfigUtil.getConfig().resourceUrls.user,
            {currentPassword: currentPassword},
            json => {
                onLogout();
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
                setShowLoeschenDialog(false);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
                setShowLoeschenDialog(false);
            }
        );
    }

    const save = () => {
        setErrorMessage(undefined);
        if (password !== password2) {
            setErrorMessage("Die beiden neuen Passwörter stimmen nicht überein.");
            return;
        }
        let data = {currentPassword: currentPassword, newPassword: password};
        FetchUtil.fetchPut(ConfigUtil.getConfig().resourceUrls.user,
            data,
            json => {
                setInfoMessage("Speichern der neuen Zugangsdaten war erfolgreich!");
                setCurrentPassword("");
                setPassword("");
                setPassword2("");
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
            }
        );
    }

    return <div className="ligashortoverview"
                style={{height: "100%", borderLeft: "10px solid green", textAlign: "left"}}>
        <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)} onClearErrorMessage={() => setErrorMessage(undefined)}/>

        <h3>Kennwort ändern</h3>
        <div style={{marginBottom: 5}}>
            <DHPasswordField id={"id-password"} label="Aktuelles Kennwort" width={"100%"} value={currentPassword} onChange={(text) => setCurrentPassword(text)}/>
        </div>
        <div style={{marginBottom: 5}}>
            <DHPasswordField id={"id-password-new"} label="Kennwort" width={"100%"} value={password} onChange={(text) => setPassword(text)}/>
        </div>
        <div style={{marginBottom: 5}}>
            <DHPasswordField id={"id-password-new2"} label="Kennwort bestätigen" width={"100%"} value={password2} onChange={(text) => setPassword2(text)}/>
        </div>
        <div style={{marginBottom: 5}}>
            <DHButtonSave onClick={() => save()} label={"Speichern"} working={false} disabled={!currentPassword || !password || !password2}/>
        </div>
        <h3>Benutzernamen ändern</h3>
        <div className="grid">
            <div className="col" style={{fontSize: 12}}>Nach einer Änderung deines Benutzernamens wirst du
                automatisch abgemeldet.
            </div>
        </div>
        <div style={{marginBottom: 5}}>
            <DHPasswordField id={"id-username"} label="Neuer Benutzername" width={"100%"} value={username} onChange={(text) => setUsername(text)}/>
        </div>
        <div style={{marginBottom: 5}}>
            <DHPasswordField id={"id-password"} label="Aktuelles Kennwort" width={"100%"} value={currentPassword} onChange={(text) => setCurrentPassword(text)}/>
        </div>
        <div style={{marginBottom: 5}}>
            <DHButtonSave onClick={() => changeUsername()} label={"Benutzernamen ändern"} working={false} disabled={!username || !currentPassword}/>
        </div>
        <h3>Account löschen</h3>
        <div className="grid">
            <div className="col" style={{fontSize: 12}}>Sobald du deinen Account löscht, werden alle persönlichen
                Daten von dir gelöscht.
            </div>
        </div>
        <div className="grid">
            <div className="col" style={{fontSize: 12}}>Diese Aktion kann nicht rückgängig gemacht werde.</div>
        </div>
        <div style={{marginBottom: 5}}>
            <DHPasswordField id={"id-password"} label="Aktuelles Kennwort" width={"100%"} value={currentPassword} onChange={(text) => setCurrentPassword(text)}/>
        </div>
        <div style={{marginBottom: 5}}>
            <DHButtonDefault onClick={() => setShowLoeschenDialog(true)} label={"Account löschen"} working={false} disabled={!currentPassword}/>
        </div>
        {externPersonMatch && <>
            <div className="grid" style={{fontWeight: "bold", marginTop: 20}}>
                <div className="col">Verknüpfung mit externen Personen (z.B. aus dem nu-System)
                </div>
            </div>
            <div style={{marginBottom: 5}}>
                <div className="grid" style={{marginTop: 20}}>
                    <div className="col-fixed" style={{width: externPersonMatch.confirmed ? 50 : 100}}>
                        {!externPersonMatch.confirmed &&
                            <DHButtonIconCheck onClick={() => setShowExternPersonConfirmDialog(true)}/>
                        }
                        <DHButtonIconDelete onClick={() => setShowExternPersonDeleteDialog(true)}/>
                    </div>
                    <div className="col">
                        <img src={externPersonMatch.confirmed ? "/images/dot_green.png" : "/images/dot_red.png"} style={{width: 15, marginRight: 5}}/>
                        {externPersonMatch.externPersonName}<br/>(PersondId: {externPersonMatch.externPersonId}/DH-SpielerId:{externPersonMatch.idShort})
                    </div>
                    <div style={{fontSize: 11, marginTop: 10}}>
                        <strong>Wichtig!!!</strong> Die Verknüpfung zu einer externen Person hat den Hintergrund, dass die Spiele/Statistiken von dieser externen Person
                        in Darthelfer bei dir angezeigt werden.<br/>
                        Die Spiele werden erst verknüpft, sobald die nächsten Spiele für diese externe Person angelegt werden. Rückwirkend wird diese Verknüpfung nicht aufgebaut.
                    </div>
                </div>
            </div>
        </>
        }

        {showExternPersonConfirmDialog &&
            <ConfirmDialog visible={true}
                           callBackOnNein={() => setShowExternPersonConfirmDialog(false)}
                           callBackOnJa={() => confirmVerknuepfung()}
                           header="Verknüpfung bestätigen"
                           textOben="Es besteht eine unbestätigte Verknüpfung zu einer externen Person."
                           textUnten="Möchtest du die Verknüpfung bestätigen?"/>
        }
        {showExternPersonDeleteDialog &&
            <ConfirmWithQuestionDialog visible={true}
                                       callBackOnNein={() => setShowExternPersonDeleteDialog(false)}
                                       callBackOnJa={() => deleteVerknuepfung()}
                                       header="Verknüpfung löschen"
                                       textOben=""
                                       textUnten="Möchtest du die Verknüpfung wirklich löschen?"/>
        }
        <ConfirmDialog visible={showLoeschenDialog}
                       callBackOnNein={() => setShowLoeschenDialog(false)}
                       callBackOnJa={() => loeschen()}
                       header="Account löschen"
                       textOben="Das Löschen deines Accounts kann nicht rückgängig gemacht werden, bitte überlege noch mal..."
                       textUnten="Möchtest du deinen Account wirklich löschen?"/>
    </div>
}
